module.exports = __webpack_public_path__ + "img/picture.b459cef2.jpg";